const HolterFileExtension = {
  MARKER: 'mrk',
  ECG: 'ecg',
} as const;

export { HolterFileExtension };
